<template>
  <span v-if="isEnabled" class="friend-icons" data-bs-toggle="tooltip" :title="popoverText">
    <span v-for="friend in viewed_by_friends" :key="friend._id">
      <FriendIcon :friend="friend" :size="15"></FriendIcon>
    </span>
  </span>
</template>


<script>
import {userStore} from "@/userStore";
import FriendIcon from "@/components/friends/icons/FriendIcon.vue";
import analytics from "@/analytics";

export default {
  name: "FriendIconGroup",
  components: {FriendIcon},
  props: ['film_id'],
  computed: {
    isEnabled() {
      return (this.viewed_by_friends.length > 0);
    },
    popoverText() {
      if ( this.viewed_by_friends.length === 0 ) {
        return '';
      }
      let returnText = 'Viewed by ';
      this.viewed_by_friends.forEach((friend, index, array) => {
        if ( index > 0 ) {
          if ( index === (array.length - 1) ) {
            returnText += ' and ';
          } else {
            returnText += ', ';
          }
        }
        //returnText += `<strong>${friend.username}</strong>`;
        returnText += friend.username;
      })
      return returnText;
    }
  },
  data() {
    return {
      userStore,
      viewed_by_friends: []
    }
  },
  created() {

    if ( !userStore.user?.friends ) {
      analytics.notifyBugsnagOfWarning('null friends param??', userStore.user);
    }

    this.viewed_by_friends = userStore.user.friends.filter((f) => {
      return f.viewed.includes(this.film_id)
    });

    // // test
    // if ( this.viewed_by_friends.length ) {
    //   this.viewed_by_friends.push(this.viewed_by_friends[0]);
    //   this.viewed_by_friends.push(this.viewed_by_friends[0]);
    //   this.viewed_by_friends.push(this.viewed_by_friends[0]);
    //   this.viewed_by_friends.push(this.viewed_by_friends[0]);
    //   this.viewed_by_friends.push(this.viewed_by_friends[0]);
    //   this.viewed_by_friends.push(this.viewed_by_friends[0]);
    //   this.viewed_by_friends.push(this.viewed_by_friends[0]);
    //   this.viewed_by_friends.push(this.viewed_by_friends[0]);
    //   this.viewed_by_friends.push(this.viewed_by_friends[0]);
    // }
  },
}
</script>


<style scoped>

.friend-icons {

  margin-left: 5px;
  margin-top: -5px;

}

.profile-pic {
}


</style>